import { render, staticRenderFns } from "./BookingDocuments.vue?vue&type=template&id=1bb1a18d&scoped=true&"
import script from "./BookingDocuments.vue?vue&type=script&lang=ts&"
export * from "./BookingDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./BookingDocuments.vue?vue&type=style&index=0&id=1bb1a18d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1a18d",
  null
  
)

export default component.exports